import {ApiClient} from '@hconnect/apiclient'
import {EventType, Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {EventsStatusesCount} from '../types'

const QueryKey = 'shift-events-count-per-status'

type Params = {
  plantId: string
  type: EventType
  from: Iso8601
  to: Iso8601
}

export const useShiftEventsCountPerStatus = (
  params: Params,
  options?: Omit<UseQueryOptions<EventsStatusesCount, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {plantId, type, from, to} = params

  return useQuery({
    queryKey: [QueryKey, plantId, type, from, to],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<EventsStatusesCount>(
        `/shifthandover/${plantId}/search/events/count-per-status`,
        {
          params: {
            type,
            from,
            to
          }
        }
      )
      return response.data
    },
    ...options
  })
}
